import { render, staticRenderFns } from "./RevenueStreamsBreakdown.vue?vue&type=template&id=13123e7b"
import script from "./RevenueStreamsBreakdown.vue?vue&type=script&lang=js"
export * from "./RevenueStreamsBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports